<template>
    <div id="buyingTaskHCM" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>买货管理</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="创建日期" prop="dateRange" label-width="100px">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small"
                        @change="dataChange"></el-date-picker>
                </el-form-item>

                <el-form-item label="任务编码" prop="tasknumber" label-width="100px">
                    <el-input v-model="queryParams.tasknumber" clearable placeholder="任务编码" size="small" />
                </el-form-item>

                <el-form-item label="是否转寄" prop="forwardstatus" label-width="100px">
                    <el-select v-model="queryParams.forwardstatus" clearable placeholder="是否转寄" size="small">
                        <el-option v-for="item in forwardstatusLIst" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="购买人" prop="payuser" label-width="100px">
                    <el-input v-model="queryParams.payuser" clearable placeholder="购买人" size="small" />
                </el-form-item>

                <el-form-item label="原箱编码" prop="encoding" label-width="100px">
                    <el-input v-model="queryParams.encoding" clearable placeholder="原箱编码" size="small" />
                </el-form-item>

                <el-form-item label="指派人" prop="dealername" label-width="100px" v-if="logintype == 'HCM'">
                    <el-select v-model="queryParams.dealername" clearable placeholder="指派人" size="small" >
                        <el-option v-for="item in appointorList" :key="item.dealername" :label="item.dealername"
                            :value="item.dealername">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label-width="100px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                </el-form-item>
            </el-form>
        </section>
        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <el-col :span="1.5">
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd(2)"
                        v-if="logintype != 'HCM'">转寄</el-button>
                </el-col>
                <!-- <el-col :span="1.5">
                    <el-button size="mini" @click="allHandleAdd" v-if="logintype != 'HCM'">批量转寄</el-button>
                </el-col> -->
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="onOpenDeleteDia(2)" v-if="logintype != 'HCM'">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="prompt" v-if="logintype != 'HCM'">
                <i class="el-icon-warning" style="margin: 0px 10px 0px 20px;color: #108cee;"></i>
                共<span class="promptFont">{{ totalNum }}</span>项,已选择<span class="promptFont">{{ openNumber }}</span>项
                <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
                <span class="promptFont">/</span>
                <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
            </div>
            <el-table v-loading="loading" :data="tableData" @row-click="taskidFun" ref="multipleTable"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" v-if="logintype != 'HCM'"></el-table-column>
                <el-table-column label="任务编码" align="left" key="tasknumber" prop="tasknumber" />
                <el-table-column label="是否转寄" align="left" key="forwardstatus" prop="forwardstatus" />
                <el-table-column label="指派人" align="left" key="dealername" prop="dealername" />
                <el-table-column label="平台" align="left" key="platform" prop="platform" />
                <el-table-column label="店铺名称" align="left" key="shopname" prop="shopname" />
                <el-table-column label="品名" align="left" key="productname" prop="productname" />
                <el-table-column label="规格" align="left" key="specification" prop="specification" />
                <el-table-column label="管控标准" align="left" key="controlstandard" prop="controlstandard" />
                <el-table-column label="单价" align="left" key="unitprice" prop="unitprice" />
                <el-table-column label="购买数量" align="left" key="paynum" prop="paynum" />
                <el-table-column label="支付金额" align="left" key="payprice" prop="payprice" />
                <el-table-column label="支付截图" align="left">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="更多图片" width="200" trigger="hover">
                            <div style="display: flex;">
                                <img v-for="(url, index) in parseScreenshots(scope.row.paypricescreenshot)" :key="index"
                                    :src="url" alt
                                    style="width: 50px; height: 50px; cursor: pointer;float: left;margin-left: 10px;"
                                    @click.stop="bigImg(url)" />
                            </div>
                            <img slot="reference" :src="parseScreenshots(scope.row.paypricescreenshot)[0]" alt
                                style="width: 50px; height: 50px; cursor: pointer;"
                                v-if="parseScreenshots(scope.row.paypricescreenshot)[0]"
                                @click.stop="bigImg(parseScreenshots(scope.row.paypricescreenshot)[0])" />
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="购买快递单号" align="left" key="couriernumber" prop="couriernumber" />
                <el-table-column label="购买人" align="left">
                    <template slot-scope="scope">
                        <div style="width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                            {{ scope.row.payuser }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="原箱编码" align="left" key="encoding" prop="encoding" />
                <el-table-column label="创建时间" align="left">
                    <template slot-scope="scope">
                        {{ scope.row.createtime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="创建人" align="left" key="createuser" prop="createuser" />
                <el-table-column label="更新时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.updatetime">
                        {{ scope.row.updatetime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新人" align="left" key="updateuser" prop="updateuser" />
            </el-table>

            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>
        <!-- 删除 -->
        <el-dialog title="提示" :visible.sync="deleteShow" width="360px" style="margin-top: 10%;" id="dialog">
            <div style="display: flex;width: 100%;justify-content:center;">
                <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
                <div>
                    <div style="font-size: 16px;">
                        你确认要删除<span>{{ delType }}</span>货任务吗？
                    </div>
                    <div style="font-size: 14px;">删除后
                        <span style="color: #e90e24;font-size: 14px;">
                            (删除买货记录之前需要先删除相关的转寄记录，已奖励的记录无法删除)？
                        </span>
                        并且不可恢复
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="deleteClassification" size="mini" :loading="ficationLoading">确
                    定</el-button>
                <el-button @click="delCancel" size="mini" type="TheCustom">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 批量任务 -->
        <el-dialog title="批量任务" class="importModal" :visible.sync="BulkImportShow" :close-on-click-modal="false"
            width="640px" id="dialog">
            <div class="wrap" style="margin: 10px;">
                <el-upload ref="newupload" class="upload-demo" drag action="hcm/hcmOrdertaskbmc/hcmOrderTaskBmcImport"
                    :auto-upload="false" multiple :before-upload="beforeUpload" accept=".xls,.xlsx"
                    :on-success="confirmUpload">
                    <i class="el-icon-upload" style="color: #BDA571;"></i>
                    <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
                        <br>
                        <span style="font-size: 14px;color: #d4d4d4;">
                            支持扩展名：.xls .xlsx
                        </span>
                    </div>
                    <el-button type="text" @click="download">下载导入模板</el-button>
                </el-upload>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
                <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取
                    消</el-button>
            </div>
        </el-dialog>
        <!-- 导入结果说明 -->
        <el-dialog title="导入结果说明" :visible.sync="responseShow" :close-on-click-modal="false" width="960px" id="dialog">
            <div style="height: 574px;overflow: auto;">
                <div class="prompt"
                    style="margin-top: 5px;margin-bottom: 8px;width: calc(100% - 40px);margin-left: 20px;margin-right: 20px;">
                    <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
                    <span class="promptFont">{{ modalInfo.message }}</span>
                </div>
                <el-table :data="responseData" style="width: 100%">
                    <el-table-column prop="dealername" label="指派人" />
                    <el-table-column prop="forwardstatus" label="是否转寄" />
                    <el-table-column prop="payuser" label="购买人" />
                    <el-table-column prop="specification" label="规格" />
                    <el-table-column prop="controlstandard" label="管控标准" />
                    <el-table-column prop="productlink" label="购买链接" />
                    <el-table-column prop="completedate" label="要求购买完成日期">
                        <template slot-scope="scope">
                            {{ scope.row.productlink | fullTime }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="purchaserequirement" label="购买要求" />
                    <el-table-column prop="stopbuyingrequest" label="停止购买要求" />
                    <el-table-column label="错误说明" fixed="right" width="200">
                        <template slot-scope="scope">
                            <span style="color: red;">
                                {{ scope.row.err_info }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="responseShow = false" size="small">确
                    定</el-button>
            </div>
        </el-dialog>
        <!-- 图片详情 -->
        <el-dialog title="图片详情" :visible.sync="bigOpen">
            <div style="text-align: center;">
                <img :src="bigurl" style="width: 400px;height: auto;">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bigOpen = false" size="small">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 添加或修改用户配置对话框hcm -->
        <hcmChildforward ref="hcmChildforward" @call-parent-method="parentMethod" />
        <hcmIndexChildDealer ref="hcmIndexChildDealer" @call-parent-method="parentMethod" />
    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import hcmIndexChildDealer from "../buyingTask/hcmIndexChildDealer.vue";
import hcmChildforward from "./hcmChildforward.vue";
export default {
    name: "buyingTaskHCM",
    data() {
        return {
            bigOpen: false,
            bigurl: '',
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                forwardstatus: null,
                encoding: null,
                tasknumber: null,
                payuser: null,
                dealername: null,
            },
            totalNum: 0,
            openNumber: 0,
            currentPage: 0,
            dateRange: [],
            loading: false,
            tableData: [],
            forwardstatusLIst: [{
                label: '已转寄',
                value: '1'
            }, {
                label: '未转寄',
                value: '0'
            }],
            appointorList: [],
            logintype: '',
            delType: '',
            checkAll: '',
            ficationLoading: false,
            deleteShow: false,

            bulLoading: false,
            BulkImportShow: false,
            selectRows: [],
            delIds: '',
            responseShow: false,
            responseData: [],
            modalInfo: {},
        };
    },
    components: {
        pagination, hcmIndexChildDealer, hcmChildforward,
    },
    created() {
        this.getList();
        this.logintype = JSON.parse(localStorage.getItem('userData')).logintype;
        this.getOrderTaskBmcDealerName();
    },
    methods: {
        parseScreenshots(screenshotString) {
            return screenshotString.split(',');
        },
        bigImg(img) {
            this.bigurl = img;
            this.bigOpen = true;
        },
        download() {
            window.open("https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E6%89%B9%E9%87%8F%E4%BB%BB%E5%8A%A1%E6%A8%A1%E6%9D%BF%EF%BC%88%E5%93%81%E7%89%8C%E6%96%B9%EF%BC%89.xlsx");
        },
        // 确定导入
        BulkImport() {
            this.bulLoading = true
            this.$refs.newupload.submit();
        },
        // 取消导入
        BulkImportShowf() {
            this.BulkImportShow = false
            this.$refs.newupload.clearFiles();
        },
        beforeUpload(file) {
            let Xls = file.name
            if (Xls.search("xls") != -1 || Xls.search("xlsx") != -1) {
                return file
            } else {
                this.$message.error('上传文件只能是 xls/xlsx 格式!')
                this.bulLoading = false
                return false
            }
        },
        confirmUpload(response) {
            if (response.status == 10000) {
                if (response.data && response.data.length > 0) {
                    this.$message({
                        message: response.message,
                        type: 'warning'
                    });
                    this.responseShow = true
                    this.responseData = response.data
                    this.modalInfo = response
                } else {
                    this.$message({
                        message: response.message,
                        type: 'success'
                    });
                    this.BulkImportShow = false
                }
                this.bulLoading = false
                this.$refs.newupload.clearFiles();
                this.getList();
            } else {
                this.bulLoading = false
                this.getList();
                this.BulkImportShow = false
                this.$message.error(response.message);
                this.$refs.newupload.clearFiles();
            }
        },
        // 勾选
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleAllSelection(row);
                    this.openNumber = this.totalNum
                    this.checkAll = 2
                });
            } else {
                this.$refs.multipleTable.clearSelection();
                this.checkAll = 1
                this.openNumber = 0
            }
        },
        handleSelectionChange(val) {
            if (this.checkAll != 2) {
                this.openNumber = val.length;
                this.selectRows = val;
            }
        },
        // 删除
        onOpenDeleteDia(e, ids) {
            this.delIds = ''
            if (ids && e == 1) {
                this.delType = '该'
                this.delIds = ids
            } else if (this.checkAll == 2 && e == 2) {
                this.delType = '全部'
                this.delIds = "checkAll"
            } else {
                this.delType = this.openNumber + '条'
                let arrIds = []
                for (let i in this.selectRows) {
                    arrIds.push(this.selectRows[i].id)
                }
                this.delIds = arrIds.join(',')
            }
            if (this.delIds == '') {
                this.$message({
                    message: '没有选中项',
                    type: 'warning'
                });
                return
            }
            this.deleteShow = true
        },
        // 取消删除
        delCancel() {
            this.deleteShow = false
            this.delType = ''
            this.checkAll = ''
            this.delIds = ''
        },
        // 确认删除
        deleteClassification() {
            this.ficationLoading = true
            let params = {
                ...this.queryParams,
                ids: this.delIds,
            }
            fetch({
                url: "/hcm/hcmOrdergoodsbmc/deleteOrderGoodsbmc",
                method: "post",
                data: params,
                noFormat: true,
                responseType: "text"
            }).then(result => {
                let res = JSON.parse(result);
                let { data } = res
                if (res.status == '10000') {
                    this.ficationLoading = false
                    this.deleteShow = false
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        getOrderTaskBmcDealerName() {
            fetch({
                url: "hcm/hcmOrdertaskbmc/getOrderTaskBmcDealerName",
                method: "get",
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.appointorList = [];
                    this.appointorList = result.data;
                }
            })
        },
        parentMethod() {
            this.getList();
        },
        dataChange() {
            if (!this.dateRange) {
                this.dateRange = []
            }
            this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
            this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
        },
        // hcm详情
        taskidFun(data) {
            // if (data.rewardsstatus == 1) {
            //     return
            // }
            let params = {
                id: data.id
            }
            fetch({
                url: "hcm/hcmOrdergoodsbmc/getOrderGoodsbmcDetails",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.$refs.hcmIndexChildDealer.handleAdd(result.data, '买货详情');
                }
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            fetch({
                url: "hcm/hcmOrdergoodsbmc/getList",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmOrdergoodsbmc/hcmOrderTaskBmcDownload",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '买货管理.xlsx')
                document.body.appendChild(link)
                link.click()
            })
        },
        // 转寄新增
        handleAdd(e) {
            let dealerid = []
            this.delIds = ''
            if (this.checkAll == 2 && e == 2) {
                this.delType = '全部'
                this.delIds = "checkAll"
            } else {
                this.delType = this.openNumber + '条'
                let arrIds = []
                for (let i in this.selectRows) {
                    arrIds.push(this.selectRows[i].id)
                    dealerid.push(this.selectRows[i].dealerid)
                }
                this.delIds = arrIds.join(',')
            }
            if (this.delIds == '') {
                this.$message({
                    message: '没有选中项',
                    type: 'warning'
                });
                return
            }
            let data = {
                data: {
                    ids: this.delIds,
                    ...this.queryParams,
                },
                dealerid: dealerid,
            }
            this.$refs.hcmChildforward.handleAdd(data, '转寄录入');
        },
        // 批量转寄
        allHandleAdd() {
            this.BulkImportShow = true
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
    }
};
</script>
<style lang="scss">
.prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-top: 8px;
    margin-bottom: 8px;
}

.promptFont {
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
}

.promptFont2 {
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
}

.el-table th {
    background-color: #f3f7ff !important;
}

.el-table__empty-text {
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
}
</style>